import { LoggerService as lgg } from "vue-components-library";

const LOG_TAG = "[COMPONENT ERROR HANDLER]";

export function ComponentErrorHandler(err, vm, info) {
  lgg.error(`${LOG_TAG} ${err.toString()}\nInfo: ${info}`, vm);
}
